export default __webpack_public_path__ + "static/media/arrow-left.62939293.svg";